import type { PortItem, PortsApi, PortsResponse } from '../../models';

const toRow = ({ id, ...port }: PortItem) => ({ ...port, id: String(id), portKey: id });

export const normalizePorts = (result: PortsResponse | null): PortsApi => {
  if (result === null) {
    return { data: [], total: 0 };
  }

  if (Array.isArray(result)) {
    return { data: result.map(toRow), total: result.length };
  }

  return {
    data: (result.items ?? []).map(toRow),
    total: result.totalCount,
  };
};
